<template>
  <div>
    <div class="bottom grid-container">
      <div v-for="team in teams" v-bind:key="team.id" class="team grid-item">
        <p class="team-name" :style="{ 'background-color': team.bgcolor }">
          {{ team.name }}
        </p>
        <p class="project-name">{{ team.project }}</p>
        <span v-if="team.thumbnail">
          <img
            class="logos"
            v-on:click="redirect(team.quickLink, location, team.name)"
            v-bind:src="'images/' + team.thumbnail"
          />
        </span>

        <p class="technologies">{{ team.technologies }}</p>
        <ul class="members">
          <li v-for="member in team.members" v-bind:key="member.member">
            <span v-if="member.linkedIn">
              <a
                class="fa fa-linkedin-square fa_custom fa-2x"
                v-bind:href="member.linkedIn"
                target="_blank"
              >
                <span class="team-member-name">{{ member.member }} </span></a
              >
            </span>
            <span v-else>
              <a target="_blank">
                <span class="team-member-name">{{ member.member }} </span></a
              >
            </span>
          </li>
        </ul>

        <a
          href="#"
          class="quick-link"
          v-if="team.quickLink"
          v-on:click="redirect(team.quickLink, location, team.name)"
        >
          <h3 id="topLink">CLICK TO VISIT THIS TEAM</h3>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import logService from "../services/LogService.js";

export default {
  name: "List",

  data: function () {
    return {};
  },

  computed: {
    location() {
      return this.$store.state.location;
    },

    teams() {
      return this.$store.state.teams;
    },
  },

  methods: {
    redirect(path, location, team) {
      console.log("********redirect to : ", path);
      console.log("********location, team: ", location, team);

      let message = {
        location: location,
        team: team,
      };

      //fire and forget
      logService
        .log(message)
        .then(() => {
          console.log("log sucessful");
        })
        .catch(() => {
          console.log("log not sucessful.");
        });

      //pause long enought to see the message
      setTimeout(() => {
        window.location.replace(path);
      }, 1000);
      // --or--
      // window.location.replace(path);
    },
  },
};
</script>

<style scoped>
.logos {
  height: "20%";
  max-width: 80%;
}

.bottom {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* background-color: #2196f3; */
  padding: 5px;
}

.grid-item {
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 5px;
  padding: 10px;
  margin: 5px;
  text-align: center;
}

.team-name {
  color: #151516;
  font-weight: bolder;
}

ol,
ul,
.schedule {
  text-align: left;
}

.project-name {
  font-weight: bold;
}

.fa_custom {
  color: #0099cc;
  text-decoration: none;
}

li {
  list-style: none;
}

img {
  max-height: 120px;
}

img:hover,
p.quick-link:hover {
  cursor: pointer;
}

span.quicklink {
  text-decoration: underline;
}

.team-member-name {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  color: black;
  margin-left: 15px;
  vertical-align: middle;
}

@media only screen and (max-width: 900px) {
  .bottom {
    display: grid;
    grid-template-columns: 1fr;
  }

  .grid-item {
    max-width: 1fr;
  }

  img {
    max-width: 1fr;
  }
}
</style>
